import { formatDateTime } from '../../utils/formatters';

const ACTION_LABELS = {
  pif_submitted: 'New PIF submitted',
  analyst_assigned: 'Analyst assigned',
  analyst_review_completed: 'Analyst review completed',
  peer_review_completed: 'Peer review completed',
  hop_review_completed: 'HoP review completed',
  iic_decision_recorded: 'IIC decision recorded',
  deal_denied: 'Deal denied',
  deal_suspended: 'Deal suspended',
  ai_summary_confirmed: 'AI summary confirmed',
  pif_reopened: 'PIF reopened',
};

export default function RecentActivity({ entries }) {
  if (!entries?.length) {
    return <p className="text-muted" style={{ fontSize: 13 }}>No recent activity.</p>;
  }

  return (
    <div>
      {entries.map(entry => (
        <div key={entry.id} style={{
          display: 'flex',
          gap: 10,
          padding: '8px 0',
          borderBottom: '1px solid var(--color-border-light)',
        }}>
          <div style={{
            width: 6, height: 6, borderRadius: '50%',
            background: 'var(--color-accent)',
            flexShrink: 0, marginTop: 6,
          }} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <p style={{ fontSize: 13, fontWeight: 500, color: 'var(--color-text)' }}>
              {ACTION_LABELS[entry.action] || entry.action}
            </p>
            <p style={{ fontSize: 11, color: 'var(--color-text-secondary)', marginTop: 1 }}>
              {formatDateTime(entry.performed_at)}
              {entry.entity_id && ` · Deal: ${entry.entity_id.substring(0, 8)}`}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
